// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1wD-9","imageUploader":"EGiftCard_imageUploader__2HAly"};